import styled from 'styled-components';

interface LabelProps {
  focus?: boolean;
}

interface MinhaProps {
  minha?: boolean;
}

export const Container = styled.div`
  /* position: absolute;
  width: 100%;
  height: 100%; */
`;

export const ListaUsuarios = styled.div`
  height: 327px;

  overflow: auto !important;

  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
`;

export const Mensagens = styled.div`
  overflow-y: auto;
  margin-bottom: 10px;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
`;

export const ContainerMensagens = styled.div`
  width: auto;
  height: 20rem;
  line-height: 12px;
  padding-top: 0;
  padding-bottom: 0;
`;

export const MessageForm = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 48px);
  float: left;
  padding: 2px;
`;
export const FloatingLabel = styled.div`
  width: calc(100% - 100px);
  width: auto;
  height: 100%;
  line-height: 12px;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  padding: 16px;
  width: 100%;
  position: relative;
  font-size: 16px;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0;
  padding: 20px 0;
  color: #757575 !important;

  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  font-weight: 400;

  overflow: hidden;
  z-index: 1;
  position: relative;
  background: #fff;
  border-radius: 2px;
  box-sizing: border-box;
`;

export const LabelMessage = styled.label<LabelProps>`
  bottom: 0;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  color: ${props => (props.focus ? '#0288D1' : 'rgba(0, 0, 0, 0.26)')};
  font-size: ${props => (props.focus ? ' 12px' : '16px')};
  top: ${props => (props.focus ? '4px' : '24px')};
  left: 0;
  right: 0;
  pointer-events: none;
  position: absolute;
  display: block;

  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
`;

export const Mensagem = styled.div<MinhaProps>`
  //opacity: 1;
  display: ${props => (props.minha ? 'flex' : 'block')};
  justify-content: ${props => (props.minha ? 'flex-end' : 'flex-start')};
  margin-top: 2px;
  border-top: 1px solid #f3f3f3;
  padding: 3px;
  // opacity: 0;
  //transition: opacity 1s ease-in-out;
`;

export const Avatar = styled.div<MinhaProps>`
  display: ${props => (props.minha ? 'table-cell' : 'none')};
  vertical-align: top;
  img {
    background-repeat: no-repeat;
    width: 30px;
    height: 30px;
    background-size: 30px;
    border-radius: 20px;
  }
`;

export const Texto = styled.div<MinhaProps>`
  display: table-cell;
  width: calc(100% - 40px);
  padding: ${props => (props.minha ? '5px 10px 5px 0px' : '5px 0 5px 10px')};
  text-align: ${props => (props.minha ? 'end' : 'start')};
`;

export const Nome = styled.div<MinhaProps>`
  display: inline-block;
  text-align: ${props => (props.minha ? 'end' : 'start')};
  width: 100%;
  padding: ${props => (props.minha ? '0 40px 0 0' : '0 0 0 40px')};

  color: #bbb;
  font-style: italic;
  font-size: 12px;
  box-sizing: border-box;
`;
